// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"index_mainLayout__3788G"};